import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {ArticlePreview} from '../../../../core/content/types/article.types'
import {faClock} from '@fortawesome/pro-regular-svg-icons/faClock'
import {TranslocoModule} from '@ngneat/transloco'
import {RouterLink} from '@angular/router'
import {ChipComponent} from '../../../../craft/chip/chip.component'
import {DatePipe, NgClass, NgOptimizedImage} from '@angular/common'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {TeaserCardComponent} from '../../../../craft/cards/teaser-card/teaser-card.component'
import {TeaserCardTitleComponent} from '../../../../craft/cards/teaser-card/teaser-card-title/teaser-card-title.component'
import {TeaserCardPlotComponent} from '../../../../craft/cards/teaser-card/teaser-card-plot/teaser-card-plot.component'
import {AuthorComponent} from '../../../../craft/author/author.component'

@Component({
  selector: 'bgo-article-preview',
  templateUrl: './article-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  styles: `
    :host {
      @apply flex w-full;
    }
    :host-context(.hero-grid-teaser-cards) :host(not:nth-child(1)) {
      @apply col-span-1;
    }
    :host-context(.hero-grid-teaser-cards) :host(:nth-child(1)) {
      @apply md:col-span-2 xl:col-span-3;
    }
  `,
  imports: [
    TranslocoModule,
    RouterLink,
    ChipComponent,
    NgOptimizedImage,
    FontAwesomeModule,
    DatePipe,
    TeaserCardComponent,
    TeaserCardTitleComponent,
    TeaserCardPlotComponent,
    AuthorComponent,
    NgClass,
  ],
})
export class ArticlePreviewComponent {
  @Input() readonly article!: ArticlePreview
  @Input() isHero = false

  readonly timeIcon = faClock
}
